export default "/profile/images/wave.svg?324e5ce74bd5444e86ac2bce0d1f5bd3";